export const SET_MODULE_SECTION_LOADING = "SET_MODULE_SECTION_LOADING";
export const SET_MODULE_SECTION_ERROR = "SET_MODULE_SECTION_ERROR";
export const CLEAR_MODULE_SECTION_ERROR = "CLEAR_MODULE_SECTION_ERROR";
export const CLEAR_MODULE_SECTION_MESSAGE = "CLEAR_MODULE_SECTION_MESSAGE";

export const GET_MODULE_SECTIONS_REQUEST = "GET_MODULE_SECTIONS_REQUEST";
export const GET_MODULE_SECTIONS_SUCCESS = "GET_MODULE_SECTIONS_SUCCESS";
export const GET_MODULE_SECTIONS_FAIL = "GET_MODULE_SECTIONS_FAIL";

export const CREATE_MODULE_SECTION_REQUEST = "CREATE_MODULE_SECTION_REQUEST";
export const CREATE_MODULE_SECTION_SUCCESS = "CREATE_MODULE_SECTION_SUCCESS";
export const CREATE_MODULE_SECTION_FAIL = "CREATE_MODULE_SECTION_FAIL";

export const UPDATE_MODULE_SECTION_REQUEST = "UPDATE_MODULE_SECTION_REQUEST";
export const UPDATE_MODULE_SECTION_SUCCESS = "UPDATE_MODULE_SECTION_SUCCESS";
export const UPDATE_MODULE_SECTION_FAIL = "UPDATE_MODULE_SECTION_FAIL";

export const DELETE_MODULE_SECTION_REQUEST = "DELETE_MODULE_SECTION_REQUEST";
export const DELETE_MODULE_SECTION_SUCCESS = "DELETE_MODULE_SECTION_SUCCESS";
export const DELETE_MODULE_SECTION_FAIL = "DELETE_MODULE_SECTION_FAIL";

export const REORDER_MODULE_SECTIONS_REQUEST = "REORDER_MODULE_SECTIONS_REQUEST";
export const REORDER_MODULE_SECTIONS_SUCCESS = "REORDER_MODULE_SECTIONS_SUCCESS";
export const REORDER_MODULE_SECTIONS_FAIL = "REORDER_MODULE_SECTIONS_FAIL";

export const setModuleSectionLoading = (payload) => ({ type: SET_MODULE_SECTION_LOADING, payload });
export const setModuleSectionError = (payload) => ({ type: SET_MODULE_SECTION_ERROR, payload });
export const clearModuleSectionError = () => ({ type: CLEAR_MODULE_SECTION_ERROR });
export const clearModuleSectionMessage = () => ({ type: CLEAR_MODULE_SECTION_MESSAGE });

export const getModuleSectionsRequest = (moduleCleId) => ({
    type: GET_MODULE_SECTIONS_REQUEST,
    payload: { moduleCleId },
});

export const getModuleSectionsSuccess = (moduleCleId, items) => ({
    type: GET_MODULE_SECTIONS_SUCCESS,
    payload: { moduleCleId, items },
});

export const getModuleSectionsFail = (payload) => ({ type: GET_MODULE_SECTIONS_FAIL, payload });

export const createModuleSectionRequest = (moduleCleId, payload, callbacks = {}) => ({
    type: CREATE_MODULE_SECTION_REQUEST,
    payload: { moduleCleId, payload, callbacks },
});

export const createModuleSectionSuccess = (payload) => ({ type: CREATE_MODULE_SECTION_SUCCESS, payload });
export const createModuleSectionFail = (payload) => ({ type: CREATE_MODULE_SECTION_FAIL, payload });

export const updateModuleSectionRequest = (moduleCleId, sectionId, payload, callbacks = {}) => ({
    type: UPDATE_MODULE_SECTION_REQUEST,
    payload: { moduleCleId, sectionId, payload, callbacks },
});

export const updateModuleSectionSuccess = (payload) => ({ type: UPDATE_MODULE_SECTION_SUCCESS, payload });
export const updateModuleSectionFail = (payload) => ({ type: UPDATE_MODULE_SECTION_FAIL, payload });

export const deleteModuleSectionRequest = (moduleCleId, sectionId, callbacks = {}) => ({
    type: DELETE_MODULE_SECTION_REQUEST,
    payload: { moduleCleId, sectionId, callbacks },
});

export const deleteModuleSectionSuccess = (payload) => ({ type: DELETE_MODULE_SECTION_SUCCESS, payload });
export const deleteModuleSectionFail = (payload) => ({ type: DELETE_MODULE_SECTION_FAIL, payload });

export const reorderModuleSectionsRequest = (moduleCleId, orderedSectionIds, callbacks = {}) => ({
    type: REORDER_MODULE_SECTIONS_REQUEST,
    payload: { moduleCleId, orderedSectionIds, callbacks },
});

export const reorderModuleSectionsSuccess = (moduleCleId, items) => ({
    type: REORDER_MODULE_SECTIONS_SUCCESS,
    payload: { moduleCleId, items },
});

export const reorderModuleSectionsFail = (payload) => ({ type: REORDER_MODULE_SECTIONS_FAIL, payload });
